<template>
	<div>

		<div style="display: flex; align-items: center">

			<div>

				<input type="checkbox" id="activador-menu">

				<nav v-if="value.personalizado">
					<ul>
						<li>
							<a @click.prevent="$emit('página', 'principal')">Inicio</a>
						</li>
						<li v-for="(e, i) in value.elementos" :key="`pgna-menu-${i}`">
							<a @click.prevent>{{ e.título }}</a>
							<ul v-if="e.elementos.length > 0">
								<li v-for="(el, j) in e.elementos" :key="`pgna-menu-${i}-${j}`">
									<a @click.prevent>{{ el.título }}</a>
								</li>
							</ul>
						</li>
					</ul>
				</nav>

				<nav v-else>
					<ul>
						<li>
							<a @click.prevent="$emit('página', 'principal')">Inicio</a>
						</li>
						<li v-for="(p, i) in páginas" :key="`pgna-menu-${i}`">
							<a @click.prevent="$emit('página', i)">{{ p.título }}</a>
						</li>
					</ul>
				</nav>

				<label for="activador-menu">
					<span></span>
				</label>

			</div>

			<div>
				<v-tooltip left>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							v-bind="attrs"
							v-on="on"
							@click="configurando = true"
							style="background-color: white">
							<v-icon>mdi-cog</v-icon>
						</v-btn>
					</template>
					<span>Configurar menú</span>
				</v-tooltip>
			</div>

		</div>

		<v-dialog
      v-model="configurando"
      max-width="1000"
    >
      <v-card>
				<v-card-title>Configuración del menú principal</v-card-title>
				<v-card-text>
					<v-form>

						<v-radio-group
							v-model="value.personalizado"
							label="Modo de menú"
						>
							<v-radio
								:value="false"
								label="Automático"
							>
							</v-radio>
							<v-radio
								:value="true"
								label="Personalizado"
							>
							</v-radio>
						</v-radio-group>

						<div v-if="value.personalizado">
							<v-subheader v-if="value.elementos.length > 0" class="mt-4 pl-0">Elementos del menú:</v-subheader>
							<v-row
								v-for="(e, i) in value.elementos"
								:key="`me-el-${i}`"
							>
								<v-col
									cols="12"
									sm="6"
								>
									<v-text-field
										v-model="e.título"
										label="Título"
										hide-details
										dense
										required
									>
										<template v-slot:prepend>
											<v-icon title="Mover este elemento hacia arriba" @click="subirElemento(i)">mdi-arrow-up-bold</v-icon>
											<v-icon title="Mover este elemento hacia abajo" @click="bajarElemento(i)">mdi-arrow-down-bold</v-icon>
										</template>
									</v-text-field>
								</v-col>
								<v-col
									cols="12"
									sm="6"
								>
									<v-text-field
										v-model="e.enlace"
										label="Enlace"
										hide-details
										dense
									>
										<template v-slot:append-outer>
											<v-icon title="Eliminar este elemento del menú" @click="eliminarElemento(i)">mdi-delete</v-icon>
											<v-icon title="Agregar elemento a submenú" @click="agregarElementoASubmenú(i)">mdi-subdirectory-arrow-left</v-icon>
										</template>
									</v-text-field>
								</v-col>
								<v-col v-if="e.elementos.length > 0" class="pl-16 pr-16">
									<v-row v-for="(el, j) in e.elementos" :key="`me-el2-${i}-${j}`">
										<v-col
											cols="12"
											sm="6"
										>
											<v-text-field
												v-model="el.título"
												label="Título"
												hide-details
												prepend-icon="mdi-chevron-right"
												dense
												required
											>
											</v-text-field>
										</v-col>
										<v-col
											cols="12"
											sm="6"
										>
											<v-text-field
												v-model="el.enlace"
												label="Enlace"
												hide-details
												append-outer-icon="mdi-delete"
												@click:append-outer="eliminarElementoDeSubmenú(i, j)"
												dense
											>
											</v-text-field>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-subheader class="mt-8 pl-0">Agregar nuevo elemento al menú:</v-subheader>
							<v-row>
								<v-col
									cols="12"
									sm="6"
								>
									<v-text-field
										v-model="título"
										label="Título"
										hide-details
										dense
										required
									></v-text-field>
								</v-col>
								<v-col
									cols="12"
									sm="6"
								>
									<v-text-field
										v-model="enlace"
										label="Enlace"
										append-outer-icon="mdi-plus"
										@click:append-outer="agregarElemento"
										hide-details
										dense
										required
									>
									</v-text-field>
								</v-col>
							</v-row>
						</div>

						<p v-else>Se mostrarán las páginas en el menú.</p>

					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-btn text @click="configurando = false">Cerrar</v-btn>
				</v-card-actions>
			</v-card>
    </v-dialog>

	</div>
</template>

<script>

export default {
	name: 'Menú',

	data: () => ({
		título: '',
		enlace: '',
		configurando: false
	}),

	props: {
		value: {
			type: Object,
			required: true
		},
		páginas: {
			type: Array,
			required: true
		}
	},

	methods: {
		agregarElemento: function() {
			if (!this.título) {
				return
			}

			this.value.elementos.push({título: this.título, enlace: this.enlace, elementos: []})

			this.título = ''
			this.enlace = ''
		},
		eliminarElemento: function(i) {
			this.$delete(this.value.elementos, i)
		},
		subirElemento: function(i) {
			if (i === 0) {
				return
			}

			let ele = this.value.elementos[i]
			this.value.elementos.splice(i, 1)
			this.value.elementos.splice(i-1, 0, ele)
		},
		bajarElemento: function(i) {
			if (i === this.value.elementos.length -1) {
				return
			}

			let ele = this.value.elementos[i]
			this.value.elementos.splice(i, 1)
			this.value.elementos.splice(i+1, 0, ele)
		},
		agregarElementoASubmenú: function(i) {
			this.value.elementos[i].elementos.push({título: '', enlace: '', elementos: []})
		},
		eliminarElementoDeSubmenú: function(i, j) {
			this.$delete(this.value.elementos[i].elementos, j)
		}
	}

}

</script>
